import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const Button = ({ 
  children, 
  className = '', 
  variant = 'default', 
  href, 
  onClick,
  size = 'default',
  disabled = false,
  'aria-label': ariaLabel,
  ...props 
}) => {
  // Estilos base y variantes
  const baseStyles = "inline-flex items-center justify-center rounded-md font-semibold uppercase tracking-wider transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none";
  
  const variants = {
    default: "bg-green-900 text-white hover:bg-green-800",
    outline: "border-2 border-beige-100 bg-white/10 backdrop-blur-sm text-beige-100 hover:bg-white/20",
    secondary: "bg-green-100 text-green-900 hover:bg-green-200",
    light: "bg-beige-100 text-green-900 hover:bg-white",
  };

  const sizes = {
    small: "text-sm px-3 py-1",
    default: "text-sm px-7 py-3.5",
    large: "text-base px-8 py-4",
  };

  const combinedClassName = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;

  const commonProps = {
    className: combinedClassName,
    'aria-label': ariaLabel,
    ...props
  };

  // Si hay un href, usar Link de react-router-dom
  if (href && !disabled) {
    return (
      <Link 
        to={href} 
        {...commonProps}
      >
        {children}
      </Link>
    );
  }

  // Si no hay href, usar un botón normal
  return (
    <button 
      onClick={onClick}
      disabled={disabled}
      {...commonProps}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'outline', 'secondary', 'light']),
  href: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['small', 'default', 'large']),
  disabled: PropTypes.bool,
  'aria-label': PropTypes.string,
};

export default Button;